export const Icons = (type) => {
  switch (type) {
    case "alarm":
      return "webconnect-alarm";
    case "fullscreen":
      return "webconnect-arrows-fullscreen";
    case "description":
      return "webconnect-info-circle";
    case "warning":
      return "webconnect-exclamation-triangle-fill";
    case "notfound":
      return "webconnect-exclamation-circle";
    case "collection":
    case "collectionSnapshot":
    case "dataSourceDatabase":
    case "Data Sources":
    case "dbExport":
    case "Browser Storage":
      return "webconnect-database";
    case "events":
    case "indexing":
      return "webconnect-diagram-3-fill";
    case "conditions":
      return "webconnect-signpost-2-fill";
    case "data-source":
      return "webconnect-hdd-stack-fill";
    case "appSettings":
      return "webconnect-columns-gap";
    case "plugins":
      return "webconnect-tools";
    case "template":
    case "PAGES":
    case "pages":
    case "js-update-page":
      return "webconnect-file-alt";
    case "sendDynamicMessage":
    case "sendDynamicMessageUsingAwsSns":
      return "webconnect-chat-left-text";
    case "info":
      return "webconnect-info-circle-fill";
    case "create":
    case "add":
      return "webconnect-plus";
    case "update":
    case "submit":
    case "save":
    case "updateCollectionWithReferenceItems":
    case "updateCollection":
    case "bulkUpdateCollection":
    case "updateCollectionAssets":
      return "webconnect-save-regular";
    case "edit":
      return "webconnect-pencil";
    case "setup":
    case "appConfig":
      return "webconnect-cog";
    case "configure":
    case "advanced":
      return "webconnect-cogs";
    case "install":
      return "webconnect-download";
    case "appConstant":
    case "fields":
      return "webconnect-form";
    case "pageSettings":
    case "pageSetting":
    case "constructors":
      return "webconnect-bricks";
    case "pageSnapshots":
    case "pageSnapshot":
    case "derivedFields":
      return "webconnect-box-arrow-in-right";
    case "customCss":
    case "customCSS":
      return "webconnect-paint-brush";
    case "constants":
    case "Delete Permissions":
      return "webconnect-vector-pen";
    case "snippetSnapshots":
    case "snippetShapshot":
    case "filters":
      return "webconnect-funnel";
    case "robotTxt":
    case "robots":
    case "constraints":
      return "webconnect-gear";
    case "list":
      return "webconnect-card-list";
    case "form":
      return "webconnect-edit";
    case "clear":
    case "eraser":
    case "reset":
    case "clearBrowserSessionData":
    case "clearBrowserStorageData":
      return "webconnect-eraser";
    case "validations":
      return "webconnect-shield";
    case "cancel":
      return "webconnect-times";
    case "next":
    case "skip":
    case "goto":
      return "webconnect-skip-forward-fill";
    case "dataSourceGoogleSheet":
      return "webconnect-file-spreadsheet";
    case "dataSourceRestAPI":
    case "subscribe":
      return "webconnect-rocket";
    case "devKey":
      return "webconnect-key";
    case "dataSourceAirtable":
    case "data-table":
      return "webconnect-table";
    case "dataSourceFirebaseRealtimeDatabase":
      return "webconnect-collection-fill";
    case "dataSourceFirebaseFunction":
      return "webconnect-code-square";
    case "dataSourceFirebaseCloudFirestore":
      return "webconnect-cloudy-fill";
    case "response":
    case "terminal":
      return "webconnect-terminal";
    case "send":
    case "send-request":
      return "webconnect-cursor-fill";
    case "back":
      return "webconnect-chevron-double-left";
    case "externalapi":
    case "webhook":
      return "webconnect-plug-fill";
    case "integromat":
      return "webconnect-power";
    case "zapier":
    case "ZAPIER":
      return "webconnect-asterisk";
    case "signUpUser":
    case "signupAndLoginUser":
    case "addNewUserToTenant":
    case "createAndAddNewUserToTenant":
    case "saveUserWithCollectionReference":
    case "updateCurrentTenantData":
    case "updateCurrentUserSettingData":
      return "webconnect-person-plus-fill";
    case "signupAndLoginAnonymousUser":
      return "webconnect-person-lines-fill";
    case "loginUser":
    case "Login / Signup":
    case "loginUserWithToken":
    case "verifyEmailOTP":
    case "verifySmsOTP":
      return "webconnect-login";
    case "socialLoginSignup":
      return "webconnect-person-circle";
    case "logoutUser":
      return "webconnect-logout";
    case "system_show_component":
    case "showModal":
    case "showBulkUpdateModal":
    case "Show / Hide Sections":
    case "conditionalOpenModal":
      return "webconnect-eye-fill";
    case "displaySubPage":
      return "webconnect-file-earmark-richtext";
    case "goToPage":
    case "Navigation":
    case "navigation":
    case "dynamicPageRedirect":
    case "customPageRedirect":
      return "webconnect-box-arrow-up-right";
    case "sendEmail":
    case "sendDynamicEmail":
    case "sendResetPasswordEmail":
      return "webconnect-envelope-fill";
    case "resetNewPassword":
      return "webconnect-wrench";
    case "chnageOldPassword":
      return "webconnect-front";
    case "showAlertMessage":
    case "Notification":
      return "webconnect-megaphone-fill";
    case "saveCollectionWithReferenceItems":
    case "saveCollection":
    case "saveCollectionAssets":
    case "verifyUserConsentEmailOTP":
    case "verifyUserConsentSmsOTP":
      return "webconnect-save-solid";
    case "updateCollectionOnPageLoad":
    case "updateCollectionFieldDerivedField":
    case "updateCollectionFieldBrowserSession":
      return "webconnect-save-fill";
    case "addToCollectionItem":
      return "webconnect-layers-fill";
    case "removeFromCollectionItem":
      return "webconnect-layers-half";
    case "deleteCollectionItem":
    case "removeCollectionFieldData":
    case "delete":
    case "deleteTypesenseCollection":
      return "webconnect-trash-solid";
    case "sendDataToExternalApi":
      return "webconnect-cloud-fog2-fill";
    case "sendDataToExternalApiAndFileDownload":
      return "webconnect-cloud-arrow-down";
    case "fileUpload":
      return "webconnect-upload";
    case "system_hide_component":
      return "webconnect-eye-slash-fill";
    case "closeModal":
    case "error":
      return "webconnect-x-circle";
    case "reloadPage":
    case "refreshCurrentLoggedInUser":
    case "refreshCurrentTenant":
    case "refreshCurrentUserSettings":
    case "reindexDataForTypesenseCollection":
      return "webconnect-refresh";
    case "refreshSection":
    case "loadingIcon":
      return "webconnect-arrow-repeat";
    case "Collection":
      return "webconnect-stack";
    case "copy":
      return "webconnect-clone";
    case "ExternalApis":
    case "localization":
    case "switchLocalizationLang":
      return "webconnect-globe";
    case "customCSSClasses":
      return "webconnect-palette";
    case "workflow":
      return "webconnect-bar-chart-steps";
    case "team":
    case "teamManagement":
    case "updateCurrentLoggedInUserData":
    case "people":
      return "webconnect-people-fill";
    case "important":
      return "webconnect-pin-angle-fill";
    case "environment":
      return "webconnect-inboxes";
    case "customCSSURL":
    case "customCssUrl":
    case "customJSCDN":
    case "customJsCDN":
    case "link":
      return "webconnect-link-45deg";
    case "customCSSFileUpload":
    case "customCssFileUpload":
      return "webconnect-file-earmark-arrow-up";
    case "customJS":
    case "customJs":
      return "webconnect-puzzle";
    case "snapshot":
    case "snapshots":
      return "webconnect-camera-fill";
    case "customCssJs":
      return "webconnect-sliders";
    case "pwa":
    case "pwaConfig":
    case "mobile":
    case "phone":
      return "webconnect-phone";
    case "search":
    case "typesenseMapping":
    case "Typesense Search":
      return "webconnect-search";
    case "text":
    case "Text Anonymization":
      return "webconnect-capital";
    case "header":
      return "webconnect-heading";
    case "paragraph":
      return "webconnect-paragraph";
    case "bootstrap_button":
      return "webconnect-bootstrap-fill";
    case "collection-form":
    case "login-form":
    case "search-form":
      return "webconnect-newspaper";
    case "input":
      return "webconnect-input";
    case "select":
    case "navbar":
    case "dependentDropDownPopulateOnChange":
      return "webconnect-menu-button-wide-fill";
    case "data-list":
      return "webconnect-list-square-rounded-interface";
    case "data-group":
      return "webconnect-list-2";
    case "Import/Export Collection Data":
      return "webconnect-file-earmark-zip";
    case "importCollectionItem":
      return "webconnect-file-arrow-up";
    case "exportCollectionItem":
      return "webconnect-file-arrow-down";
    case "codeExport":
      return "webconnect-cloud-download";
    case "customFonts":
      return "webconnect-font";
    case "drapcode-icons":
    case "globalTheme":
    case "overwriteDefaultUI":
      return "webconnect-star";
    case "iframe":
      return "webconnect-frame";
    case "link-box":
      return "webconnect-link";
    case "box":
      return "webconnect-square";
    case "jumbotron":
      return "webconnect-credit-card-2-front-fill";
    case "stripe-connect-buy":
      return "webconnect-cart-check";
    case "timeout":
      return "webconnect-hourglass-split";
    case "logs":
      return "webconnect-file-text";
    case "resetFormFields":
      return "webconnect-eraser-fill";
    case "Form":
    case "OCR to Text":
      return "webconnect-file-earmark-text-fill";
    case "submitSelectedForm":
      return "webconnect-save2-fill";
    case "showConfirmationMessage":
      return "webconnect-shield-fill-exclamation";
    case "customTheme":
      return "webconnect-file-zip";
    case "triggerZap":
      return "webconnect-cloud-fog2";
    case "encryption":
    case "sendDataToExternalApiAndAuthorize":
    case "Permission":
    case "permissionLevelSecurity":
    case "rowLevelSecurity":
      return "webconnect-shield-lock ";
    case "decryption":
      return "webconnect-shield-slash";
    case "continue":
      return "webconnect-arrow-right";
    case "previous":
      return "webconnect-arrow-left";
    case "sync":
      return "webconnect-arrow-left-right";
    case "step-complete":
      return "webconnect-check2-circle";
    case "step-pending":
      return "webconnect-plus-circle-dotted";
    case "version":
      return "webconnect-patch-plus";
    case "toggle":
      return "webconnect-toggles";
    case "notification":
    case "notificationSetting":
      return "webconnect-bell";
    case "meta-fields":
      return "webconnect-receipt";
    case "removeTenantFromMultipleRoles":
    case "removeUserFromTenant":
      return "webconnect-person-dash-fill";
    case "addUserToTenant":
      return "webconnect-person-check-fill";
    case "switchUserTenant":
      return "webconnect-address-book";
    case "switchSubTenant":
      return "webconnect-address-book-outline";
    case "setBrowserSessionData":
      return "webconnect-journal-plus";
    case "setBrowserStorageData":
      return "webconnect-inboxes-fill";
    case "Others":
    case "Miscellaneous":
      return "webconnect-command";
    case "dateFormat":
      return "webconnect-calendar2-month";
    case "customComponent":
    case "displayCustomComponent":
      return "webconnect-easel";
    case "htmlContent":
      return "webconnect-code-slash";
    case "saveCollectionDraft":
      return "webconnect-archive-fill";
    case "updateCollectionDraft":
      return "webconnect-archive";
    case "switchEntity":
      return "webconnect-box-seam";
    case "customDataMapping":
      return "webconnect-bezier2";
    case "dashboard":
      return "webconnect-x-diamond-fill";
    case "PROFILER":
    case "profiler":
      return "webconnect-speedometer2";
    case "system-activity":
      return "webconnect-cpu";
    case "publish-activity":
      return "webconnect-paper-plane";
    case "pause":
      return "webconnect-pause";
    case "resume":
      return "webconnect-play";
    case "on-boarding":
      return "webconnect-house-door-fill";
    case "AI/ChatGPT":
    case "AI / ChatGPT":
    case "startNewGptConversation":
    case "continueGptConversation":
    case "meetings":
      return "webconnect-lightbulb-fill";
    case "resources":
      return "webconnect-cloud-arrow-up";
    case "view":
      return "webconnect-eye";
    case "remove":
      return "webconnect-trash-regular";
    case "verifyTwoFactorAuthentication":
    case "verificationprocess":
      return "webconnect-shield-lock-fill";
    case "pdfToText":
    case "anyFileToText":
      return "webconnect-file-text";
    case "Loan Management":
    case "createLoanRepayments":
      return "webconnect-wallet2";
    case "amazonTextract":
      return "webconnect-file-text";
    case "sitemapXml":
      return "webconnect-diagram-3";
    case "deployment":
      return "webconnect-nut-fill";
    case "history":
      return "webconnect-journal-text";
    case "nlpAnonymization":
      return "webconnect-text-center";
    case "customTermsAnonymization":
      return "webconnect-file-earmark-font";
    case "Docusign":
      return "webconnect-pen-fill";
    case "initiateDocusign":
      return "webconnect-pen";
    case "sendForEsign":
      return "webconnect-paper-plane";
    case "aiModelConfig":
    case "aiModelConfiguration":
      return "webconnect-outlet";
    case "github":
      return "webconnect-github";
    case "runJavaScriptCode":
      return "webconnect-file-code-fill";
    case "loaderScreen":
      return "webconnect webconnect-refresh";
    case "importProject":
      return "webconnect webconnect-box-arrow-down";
    case "OTP Authentication":
      return "webconnect-shield-check";
    case "clock":
      return "webconnect-clock";
    case "model":
      return "webconnect-box";
    case "platform":
      return "webconnect-hdd-stack";
    case "left":
      return "webconnect-arrow-left-short";
    case "right":
      return "webconnect-arrow-right-short";
    case "dots":
      return "webconnect-three-dots";
    case "key":
      return "webconnect-key-fill";
    case "user":
      return "webconnect-person-fill";
    case "moveLeft":
      return "webconnect-chevron-right";
    case "brightnessHigh":
      return "webconnect-brightness-high";
    case "brightnessLow":
      return "webconnect-moon";
    case "question":
      return "webconnect-question-circle";
    case "mic":
      return "webconnect-mic";
    case "extension":
      return "webconnect-grid";
    case "file":
      return "webconnect-earmark-fill";
    case "questionResponse":
      return "webconnect-star-regular";
    case "client":
      return "webconnect-file-earmark-person-fill";
    case "import":
      return "webconnect-box-arrow-down";
    case "voice":
      return "webconnect-broadcast";
    case "call":
      return "webconnect-telephone-fill";
    case "correct":
      return "webconnect-check";
    case "down":
      return "webconnect-chevron-down";
    case "heart":
      return "webconnect-heart-fill";
    case "billing":
      return "webconnect-wallet2";
    case "payment":
      return "webconnect-credit-card";
    case "credited":
      return "webconnect-arrow-up-circle";
    case "apiUsage":
      return "webconnect-arrow-down-circle";
    case "email":
      return "webconnect-at";
    case "repeat":
      return "webconnect-arrow-repeat";
    case "light":
      return "webconnect-lightning-charge-fill ";
    case "arrow-down":
      return "webconnect-chevron-compact-down";
    case "load":
      return "webconnect-arrow-clockwise";
    case "meeting":
      return "webconnect-camera-video";
    case "check":
      return "webconnect-check2";
    case "arrowUp":
      return "webconnect-arrow-up";
    case "arrowDown":
      return "webconnect-arrow-down ";
    case "sun":
      return "webconnect-sun";
    case "moon":
      return "webconnect-moon";
    case "calendar":
      return "webconnect-calendar-fill";
    case "integration":
      return "webconnect-grid-fill";
    case "cross":
      return "webconnect-x";
    case"google":
      return "webconnect-google";
    case "rework":
      return "webconnect-refresh";
    case "redirect":
      return 'webconnect-box-arrow-up-right';
    case "sidebar":
      return 'webconnect webconnect-layout-text-sidebar-reverse';
    case "chat":
      return 'webconnect webconnect-chat';
    case "dot":
      return 'webconnect webconnect-circle-fill';
     case "allTasks":
      return "webconnect-list-task";
    case "myTasks":
      return "webconnect-clipboard-check";
    default:
      return "webconnect-edit";
  }
};
